import React, { useEffect } from 'react';
import { Form } from 'antd';

import { LabelWithTooltip } from 'components';
import { UserAccountsAutocomplete } from 'modules';

import { AccountListItemType } from 'types/accounts';
import { FormValuesType, ISearchAccountBaseFormProps } from './SearchAccountBaseForm.types';

import './SearchAccountBaseForm.styles.scss';

const SearchAccountBaseForm = ({
  values,
  loading,
  autoFocus,
  allowClear,
  tooltip,
  label = 'form.label.subaccount',
  placeholder = 'form.placeholder.searchAndSelectAccount',
  onFinish,
  onClear,
  inputProps,
  className = '',
  ...props
}: ISearchAccountBaseFormProps) => {
  const initialValues: FormValuesType = { accountName: values?.accountName || '' };

  const [form] = Form.useForm();

  const handleSelectUser = async (account: AccountListItemType) => {
    if (account) {
      await onFinish(account);
    }
  };

  useEffect(() => {
    const accountName = values.accountName;

    if (accountName) {
      form.setFieldsValue({ accountName });
    }
  }, [form, values.accountName]);

  return (
    <Form
      form={form}
      initialValues={initialValues}
      layout="vertical"
      className={`np-search-account-base-form ${className}`}
      {...props}
    >
      <Form.Item
        label={label && tooltip ? <LabelWithTooltip label={label} tooltip={tooltip} /> : label}
        name="accountName"
      >
        <UserAccountsAutocomplete
          fullAccount
          disabled={loading}
          autoFocus={autoFocus}
          allowClear={allowClear}
          placeholder={placeholder}
          onSelect={handleSelectUser}
          onClear={onClear}
          inputProps={inputProps}
        />
      </Form.Item>
    </Form>
  );
};

export default SearchAccountBaseForm;
